module.exports = __webpack_public_path__ + "img/UTQUAI-10.5b9c6cf0.jpg";